import { SurveyProps } from '../types/survey';

export function getSurveyInitialDataHydrationKey(
  initialData?: Partial<SurveyProps> | null,
) {
  if (!initialData?.id) {
    return '';
  }

  return JSON.stringify({
    id: initialData.id,
    lastUpdated: initialData.lastUpdated?.time || 0,
    formFields: initialData.formFields || [],
    formOptions: initialData.formOptions || {},
    floorPlans: initialData.floorPlans || [],
  });
}
